import { FC, useMemo } from 'react';
import { DateTimeHelper } from '@/utils/dateTimeHelper';
import { FinanceAnalyticsByMonthsMonthResponseDto } from '../../types/finances-dto';
import { useFinancesPageFilter } from '../../store/useFinancesPageFilter';
import { eachMonthOfInterval, isSameMonth } from 'date-fns';
import CurrencyValue from '../CurrencyValue';

type Props = {
    values?: FinanceAnalyticsByMonthsMonthResponseDto[] | null;
};

const AnalyticsElement: FC<Props> = ({ values }) => {
    const { filter } = useFinancesPageFilter();

    const mergedValues = useMemo(() => {
        const { startDate, endDate } = filter;
        if (!startDate || !endDate) return [];

        const months = eachMonthOfInterval({
            start: new Date(startDate),
            end: new Date(endDate),
        });

        return months.map((month) => {
            const match = values?.find((v) => isSameMonth(v.month, month));
            return { month, value: match?.value ?? 0 };
        });
    }, [filter, values]);

    const valuesContent = (
        <div className="flex flex-col gap-4">
            {mergedValues?.map(({ month, value }, index) => (
                <div key={index} className="my-1 flex justify-between text-sm">
                    <span className="text-popover-800">{DateTimeHelper.formatDate(month, 4)}</span>
                    <span className="text-popover-800"><CurrencyValue value={value} asset='other' /></span>
                </div>
            ))}
        </div>
    );

    return (
        <div className="max-h-62 pl-10.5 pr-6 flex flex-col gap-4 overflow-y-auto">
            {valuesContent}
        </div>
    );
};

export default AnalyticsElement;
